<template>
  <div class="custom-wrapper">
    <div v-if="isLoading" class="row">
      <div class="col">
        <FontAwesomeIcon icon="fa-solid fa-spinner me-2" spin />
        <span class="ms-2">loading...</span>
      </div>
    </div>
    <table v-else class="table table-striped">
      <colgroup>
        <col style="width: 25%" />
        <col style="width: 25%" />
        <col style="width: 50%" />
      </colgroup>
      <thead class="bg-white table-sticky">
        <tr class="custom-table-header">
          <th>Partner</th>
          <th>Location</th>
          <th>
            <table class="custom-table">
              <colgroup>
                <col style="width: 60%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
              </colgroup>
              <tr>
                <th colspan="3" class="text-center">Counts</th>
              </tr>
              <tr>
                <th>Type</th>
                <th class="text-right"># Locations</th>
                <th class="text-right"># Users</th>
              </tr>
            </table>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="location in locations" :key="location.id">
          <td>{{ location.partner }}</td>
          <td>{{ location.location }}</td>
          <td>
            <table class="table">
              <colgroup>
                <col style="width: 60%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
              </colgroup>
              <tbody>
                <tr v-for="count in getCounts(location.counts)" :key="count.id">
                  <td>{{ count.type }}</td>
                  <td class="text-right">{{ count.totalNum }}</td>
                  <td class="text-right">{{ count.numUsers }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'LocationStats',
  components: {
    FontAwesomeIcon
  },
  mounted() {
    this.getLocationStats()
  },
  computed: {
    ...mapState(locationStore, ['loading', 'locationStats']),
    isLoading() {
      let _is = false
      if (this.loading) {
        _is = this.loading.locationStats
      }
      return _is
    },
    locations() {
      let _locations = []
      if (this.locationStats) {
        this.locationStats.forEach((element) => {
          _locations.push({
            id: element.firm,
            partner: element.partnerName,
            location: element.firmName,
            counts: element.counts
          })
        })
      }
      return _locations
    }
  },
  methods: {
    ...mapActions(locationStore, ['getLocationStats']),
    getCounts(data) {
      let counts = []
      if (data) {
        counts = JSON.parse(data)
      }
      return counts
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  height: 550px;
  max-height: 550px;
}
.custom-table {
  width: 100%;
}
.custom-table-header {
  th {
    font-weight: bold;
  }
}
</style>
